/**
 * Summary — three-up stat block at the top of the owner dashboard.
 *
 * Pulled from `me.claims_count` + `me.sponsorships`; "active" is the
 * subset of sponsorships flagged `is_active=true` by the backend.
 */
export default function SummaryStats({ me }) {
  const active = me.sponsorships.filter((s) => s.is_active).length;
  const total = me.sponsorships.length;
  return (
    <div className="grid grid-cols-3 gap-3">
      <Stat label="Verified claims" value={me.claims_count} />
      <Stat label="Active sponsorships" value={active} accent />
      <Stat label="Lifetime boosts" value={total} />
    </div>
  );
}

function Stat({ label, value, accent }) {
  return (
    <div
      className={`rounded-2xl border p-4 ${
        accent
          ? "border-[#D95D39] bg-[#FFF3EE]"
          : "border-[#E5E1D8] bg-white"
      }`}
    >
      <div className="text-[10px] uppercase tracking-[0.18em] font-bold text-[#647466]">
        {label}
      </div>
      <div className="font-display text-3xl font-semibold mt-1 text-[#2A3B2C]">
        {value}
      </div>
    </div>
  );
}
